import { convertMultipicklistValueToKey } from 'utils/idUtils';
import { cloneDeep } from 'lodash';
import { FIELD_TYPES } from '../../utils/constants';

function fromGQL(obj) {
  const clonedObj = cloneDeep(obj);
  const { value, ...returnableField } = clonedObj;

  if (value && value.options) {
    const conformedOptions = {};
    const optionsOrder = [];

    value.options.forEach((option) => {
      const optionId = convertMultipicklistValueToKey(option.value);

      conformedOptions[optionId] = {
        value: option.value,
        label: option.label,
        shouldDisplay: true,
      };

      optionsOrder.push(optionId);
    });

    if (value.adminType && value.adminType === FIELD_TYPES.MULTIPICKLIST) {
      delete value.stacked;
      delete value.adminType;
      return {
        ...returnableField,
        editors: {
          multipicklistConfig: { ...value, options: conformedOptions, optionsOrder },
          editorType: FIELD_TYPES.MULTIPICKLIST,
        },
      };
    }

    return {
      ...returnableField,
      editors: {
        multipicklistConfig: { ...value, options: conformedOptions, optionsOrder },
        editorType: FIELD_TYPES.MULTIPICKLIST,
      },
    };
  }

  return {
    ...returnableField,
    editors: {
      multipicklistConfig: { options: {}, defaultOption: '', optionsOrder: [] },
      editorType: FIELD_TYPES.MULTIPICKLIST,
    },
  };
}

function toGQL({ editors }) {
  const { options, optionsOrder } = editors.multipicklistConfig;
  const conformedOptions = optionsOrder.reduce((acc, curr) => {
    if (options[curr].shouldDisplay) {
      acc.push({
        value: options[curr].value,
        label: options[curr].label,
      });
    }
    return acc;
  }, []);

  const conformedConfig = {
    ...editors.multipicklistConfig,
    options: conformedOptions,
  };
  delete conformedConfig.optionsOrder;

  if (editors.editorType === FIELD_TYPES.RADIO_BUTTON) {
    conformedConfig.stacked = true;
    conformedConfig.adminType = FIELD_TYPES.MULTIPICKLIST;
    return {
      value: conformedConfig,
      type: FIELD_TYPES.RADIO_BUTTON,
    };
  }
  return { value: conformedConfig };
}

export default {
  fromGQL,
  toGQL,
};
